import { render } from "./PartnerTypeView.vue?vue&type=template&id=4512cf3c"
import script from "./PartnerTypeView.vue?vue&type=script&lang=js"
export * from "./PartnerTypeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__